<template>
    <div class="auth-errors">
        <span v-if="errors.length" class="icon icon-exclamation-triangle"></span>
        <span v-for="error in errors">{{ $te(error) ? $t(error) : error }}</span>
    </div>
</template>

<script>
export default {
    name: "AuthErrors",
    props: {
        errors: {
            type: Array,
            default() {
                return []
            }
        }
    }
}
</script>

<style scoped>

</style>